// extracted by mini-css-extract-plugin
export default {"base":"Emails_base__tjJAt","header":"Emails_header__DlSqF","content":"Emails_content__M4Mpa","body":"Emails_body__bl+fQ"};